var $ = require('jquery');

//ページ内リンク用のスムーススクロール（現在はindex.htmlのみ作動）

$(function() {
  $('a[href^="#"]:not([href$="#"])').click(function() {
    var href = $(this).attr('href');
    var pos = $(href).offset().top - 80;
    var duration = 1000;
    $('body, html').animate({ scrollTop: pos }, duration, 'swing');
    return false;
  });
});
